// Socket.IO client for the web app. Connects to the same origin the page is
// served from, presents the JWT for auth, and triggers a callback whenever the
// server emits `data:changed` (after any save or delete by any client).

import { io, Socket } from 'socket.io-client';

export type ChangeEvent = {
  type: 'customers' | 'bookings' | 'contacts';
  payload?: unknown;
  at: string;
};

let socket: Socket | null = null;

export function connect(onChange: (e: ChangeEvent) => void): void {
  if (socket?.connected) return;

  const token = localStorage.getItem('ottosbarn_token');
  if (!token) return;

  socket = io({
    // Default origin (same host the SPA is served from). Works for both local
    // dev (Vite proxies websockets) and Azure (single App Service).
    transports: ['websocket', 'polling'],
    auth: { token },
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
  });

  socket.on('data:changed', (evt: ChangeEvent) => {
    onChange(evt);
  });
}

export function disconnect(): void {
  if (socket) {
    socket.removeAllListeners();
    socket.disconnect();
    socket = null;
  }
}
